import withValidations from '../../common/withValidations';

const validations = {
  patientFirstName: (value, props) => {
    if (props.agencyRequiresPatientInfo && (!props.facesheetAttached || props.isCar) && value.length === 0) {
      return 'Patient must have a first name';
    }
    if (value && value.length > 255) {
      return 'Cannot exceed 255 characters';
    }
    return null;
  },
  patientMiddleName: value => {
    if (value && value.length > 10) {
      return 'Cannot exceed 10 characters';
    }
    return null;
  },
  patientLastName: (value, props) => {
    if (props.agencyRequiresPatientInfo && (!props.facesheetAttached || props.isCar) && value.length === 0) {
      return 'Patient must have a last name';
    }
    if (value && value.length > 255) {
      return 'Cannot exceed 255 characters';
    }
    return null;
  },
  patientEmail: (value, props) => {
    if (value && !/^[\w+-]+(\.[+\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) {
      return 'Patient must have a valid email';
    }
    return null;
  },
  patientBirthday: (value, props) => {
    if (props.agencyRequiresPatientInfo && (!props.facesheetAttached || props.isCar) && !value) {
      return 'Patient must have a date of birth';
    }
    return null;
  },
  patientMRN: value => {
    if (value && value.length > 50) {
      return 'Cannot exceed 50 characters';
    }
    return null;
  },
  patientSsn: value => {
    if (!value) {
      return null;
    }

    if (!/^\d{9}/i.test(value)) {
      return 'SSN has a wrong format. Try 999-99-9999 or empty field if patient does not have SSN';
    }

    return null;
  },
  phone: (value, props) => {
    if (
      (props.isNonTransport || (!props.isNonTransport && props.agencyRequiresPatientInfo && props.requirePhone)) &&
      (!value || (value && value.length === 0))
    ) {
      return 'Patient must have a phone number';
    }
    if (value && value.length < 14) {
      return 'Patient phone number must have all digits';
    }
    return null;
  },
};

export default component => withValidations(validations)(component);
